import Vue from 'vue'

import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)

import '@/assets/scss/bootstrap.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
